import { render, staticRenderFns } from "./StatusTransitionRecord.vue?vue&type=template&id=a53ca3be&scoped=true"
import script from "./StatusTransitionRecord.vue?vue&type=script&lang=js"
export * from "./StatusTransitionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53ca3be",
  null
  
)

export default component.exports